import React, { createContext, useEffect, useContext } from 'react';
import { CouponErrorBoundary } from './src-components-CouponErrorBoundary-CouponErrorBoundary.js';
import { useGetCouponCode } from './src-hooks-useGetCouponCode.js';
import { usePricingContext } from './src-hooks-usePricingContextInitialization.js';
import { getLocalizationsFor } from './src-localization-getLocalizations.js';
import { useCouponDetailsStore } from './src-store-couponDetails.store.js';
import { getMarketFromLocale } from './src-utils-locale.util.js';

const CouponCallout = createContext({});
const CouponCalloutProvider = ({ baseConfig, children }) => {
  const { tenant, locale, developmentMode, pageId } = baseConfig;
  if (!tenant || !locale || !pageId) {
    throw new Error("Missing tenant, locale or pageId in baseConfig");
  }
  const market = getMarketFromLocale(locale);
  usePricingContext(tenant, market, developmentMode);
  const initializeScopedData = useCouponDetailsStore((state) => state.initializeScopedData);
  initializeScopedData(pageId);
  const setLocalizations = useCouponDetailsStore((state) => state.setLocalizations);
  useEffect(() => {
    const localizations = getLocalizationsFor(locale);
    setLocalizations(localizations);
  }, [locale]);
  const couponCode = useGetCouponCode();
  const setCouponCode = useCouponDetailsStore((state) => state.setCouponCode);
  useEffect(() => {
    if (couponCode) {
      setCouponCode(couponCode);
    }
  }, [couponCode]);
  return /* @__PURE__ */ React.createElement(CouponErrorBoundary, null, /* @__PURE__ */ React.createElement(CouponCallout.Provider, { value: baseConfig }, children));
};
const useScopedBaseConfig = () => {
  return useContext(CouponCallout);
};

export { CouponCalloutProvider, useScopedBaseConfig };
//# sourceMappingURL=src-contexts-CouponCalloutConfig.context.js.map
